exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table.reportTbl[data-v-e7c49aa2]{width:100%;border-collapse:collapse}.reportTbl td[data-v-e7c49aa2]{border:1px solid #ccc;padding:6px}.reportTbl tr td[data-v-e7c49aa2]{text-align:left;line-height:15px}.txtRight[data-v-e7c49aa2]{text-align:right!important}.reportTbl tr.txtCenter td[data-v-e7c49aa2]{text-align:center}.reportTbl tr.tb-td td[data-v-e7c49aa2]{font-weight:700;text-align:center;border:none}td.textCenter[data-v-e7c49aa2]{text-align:center!important}td.textRight[data-v-e7c49aa2]{text-align:right!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e7c49aa2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reportGenerate/reportsB/DesignatedAccountActivityStatement.vue
// module id = 1624
// module chunks = 3